<div class="locked-page">
    <div class="locked-card">

        <!-- Icon -->
        <div class="locked-icon">
            <div class="icon-mask" [style.--icon-url]="'url(assets/icons/lock.svg)'"></div>
        </div>

        <!-- Heading -->
        <h1 class="locked-title">Account temporarily locked</h1>
        <p class="locked-subtitle">
            Too many failed attempts. For your security, sign in is disabled.
        </p>

        <!-- Countdown -->
        @if (!isExpired()) {
        <div class="countdown-box">
            <span class="countdown-label">Try again in</span>
            <div class="countdown-timer">
                {{ minutes() }}<span class="countdown-colon">:</span>{{ seconds() }}
            </div>
        </div>
        } @else {
        <div class="countdown-box countdown-box--expired">
            <span class="countdown-label">Lockout expired</span>
            <div class="countdown-ready">You can try logging in again</div>
        </div>
        }

        <!-- Actions -->
        <button class="btn-primary" (click)="onResetPassword.emit()">
            Reset password
        </button>

    </div>
</div>